module.exports = __webpack_public_path__ + "static/media/loupe.c5f8473f.svg";